<template>
  <div class="qgPollutionSourcesMonitor" ref="qgPollutionSourcesMonitor">
    <div @click="clickHandle" class="button" :class="btnClass">切换</div>
    <div @click="triggleHandle" class="triggleBtn">{{ triggleText }}</div>
    <div
      v-if="customerId == 8"
      @click="triggleCO"
      class="triggleBtn triggleBtnCo"
      :class="[isShowC0 && 'highLight']"
    >
      监控
    </div>
    <el-row style="opacity: 0">
      <el-col :span="24" :style="{ textAlign: 'right', marginTop: '-10px' }">
        <div class="dot1">•</div>
        <div class="dot1-title">≤80%限值</div>

        <div class="dot2">•</div>
        <div class="dot1-title">＞80%限值且≤限值</div>

        <div class="dot3">•</div>
        <div class="dot1-title">＞限值</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="tableData"
          :header-cell-class-name="getHeaderCellClass"
          :header-row-class-name="getHeadRowClass"
          :cell-class-name="getCellClass"
          :row-class-name="getRowClass"
          class="source_table"
          ref="sourceTable"
          v-loading="isLoad"
          :element-loading-text="loadStr"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
          :style="{ marginTop: '0px' }"
          :maxHeight="autoHeight"
          :row-style="{ height: '27px' }"
          empty-text="--"
        >
          <el-table-column prop="index1" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="points1" label="环保点位" width="">
            <template #default="scope">
              <span :title="scope.row['points1']">{{
                scope.row["points1"]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!isShowC0 && customerId != 8"
            prop="standard1"
            label="超低标准"
            width="60"
          ></el-table-column>
          <el-table-column prop="monitor1" label="监测值" :width="isShowC0 ? 100 :70">
            <!-- 三个颜色改成一个，应付检查1、ff7f7f 2、f5a623 3、99f5ff -->
            <template #default="scope">
              <span style="color: #99f5ff">{{ scope.row["monitor1"] }}</span>
              <!--span
                v-if="scope.row['monitor1'] > scope.row['standard1']"
                style="color: #ff7f7f"
                >{{ scope.row["monitor1"] }}</span
              >
              <span
                v-else-if="
                  scope.row['monitor1'] <= scope.row['standard1'] &&
                  scope.row['monitor1'] > 0.8 * scope.row['standard1']
                "
                style="color: #f5a623"
                >{{ scope.row["monitor1"] }}</span
              >
              <span v-else style="color: #99f5ff">{{ scope.row["monitor1"] }}</span-->
            </template>
          </el-table-column>

          <el-table-column prop="index2" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="points2" label="环保点位" width="">
            <template #default="scope">
              <span :title="scope.row['points2']">{{
                scope.row["points2"]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!isShowC0 && customerId != 8"
            prop="standard2"
            label="超低标准"
            width="60"

          >
          </el-table-column>
          <el-table-column prop="monitor2" label="监测值"  :width="isShowC0 ? 100 :70">
            <template #default="scope">
              <span style="color: #99f5ff">{{ scope.row["monitor2"] }}</span>
              <!--span
                v-if="scope.row['monitor2'] > scope.row['standard2']"
                style="color: #ff7f7f"
                >{{ scope.row["monitor2"] }}</span
              >
              <span
                v-else-if="
                  scope.row['monitor2'] <= scope.row['standard2'] &&
                  scope.row['monitor2'] > 0.8 * scope.row['standard2']
                "
                style="color: #f5a623"
                >{{ scope.row["monitor2"] }}</span
              >
              <span v-else style="color: #99f5ff">{{ scope.row["monitor2"] }}</span-->
            </template>
          </el-table-column>

          <el-table-column prop="index3" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="points3" label="环保点位" width="">
            <template #default="scope">
              <span :title="scope.row['points3']">{{
                scope.row["points3"]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="standard3"
            label="超低标准"
            v-if="!isShowC0 && customerId != 8"
            width="60"

          >
          </el-table-column>
          <el-table-column prop="monitor3" label="监测值"  :width="isShowC0 ? 100 :70">
            <template #default="scope">
              <span style="color: #99f5ff">{{ scope.row["monitor3"] }}</span>
              <!--span
                v-if="scope.row['monitor3'] > scope.row['standard3_']"
                style="color: #ff7f7f"
                >{{ scope.row["monitor3"] }}</span
              >
              <span
                v-else-if="
                  scope.row['monitor3'] <= scope.row['standard3_'] &&
                  scope.row['monitor3'] > 0.8 * scope.row['standard3_']
                "
                style="color: #f5a623"
                >{{ scope.row["monitor3"] }}</span
              >
              <span v-else style="color: #99f5ff">{{ scope.row["monitor3"] }}</span-->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { unref } from "vue";

export default {
  //import引入的组件需要注入到对象中才能使
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      sourceData: [],
      autoHeight: 711,
      branchFactoryId: "",
      input: "",
      pageNo: 1,
      currentIndex: 0,
      pageSize: 100,
      total: "",
      emNameVal: "",
      isLoad: false,
      loadStr: "拼命加载中",
      delayLoader: "",
      scrollPage: 1,
      emissionType: "",

      tableData: [],
      tableArr: [],
      timer: null,
      formatTimer: null,
      isAuto: false,
      isShowC0: false,
    };
  },
  //计算属性 类似于data概念
  computed: {
    sourceDataComputed() {
      return unref(this.getSourceData);
    },

    getHeaderCellClass() {
      return (obj) => {
        if (this.isShowC0 || this.customerId == 8) {
          if (
            obj.columnIndex === 0 ||
            obj.columnIndex === 3 ||
            obj.columnIndex === 6
          ) {
            return "thClass_";
          } else {
            return "thClass";
          }
        } else {
          if (
            obj.columnIndex === 0 ||
            obj.columnIndex === 4 ||
            obj.columnIndex === 8
          ) {
            return "thClass_";
          } else {
            return "thClass";
          }
        }
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      return (obj) => {
        if(this.isShowC0  || this.customerId == 8) {
          if (
          obj.columnIndex === 0 ||
          obj.columnIndex === 3 ||
          obj.columnIndex === 6
        ) {
          return "tdClass_";
        } else if (
         
          obj.columnIndex === 2 ||
          obj.columnIndex === 5 ||
          obj.columnIndex === 8 
        ) {
          return "tdClass_2";
        } else if (
          obj.columnIndex === 1 ||
          obj.columnIndex === 4 ||
          obj.columnIndex === 7
        ) {
          return "tdClass_3";
        } else {
          return "tdClass";
        }
        } else {
          if (
          obj.columnIndex === 0 ||
          obj.columnIndex === 4 ||
          obj.columnIndex === 8
        ) {
          return "tdClass_";
        } else if (
          obj.columnIndex === 2 ||
          obj.columnIndex === 3 ||
          obj.columnIndex === 6 ||
          obj.columnIndex === 7 ||
          obj.columnIndex === 10 ||
          obj.columnIndex === 11
        ) {
          return "tdClass_2";
        } else if (
          obj.columnIndex === 1 ||
          obj.columnIndex === 5 ||
          obj.columnIndex === 9
        ) {
          return "tdClass_3";
        } else {
          return "tdClass";
        }
        }
      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },

    triggleText() {
      if (this.isAuto) {
        // 自动
        return "手动";
      } else {
        // 手动
        return "自动";
      }
    },
    btnClass() {
      if (this.isAuto) {
        return "btn_disabled";
      } else {
        return "btn";
      }
    },
  },
  //监控data中的数据变化
  watch: {
    isAuto: {
      handler(newValue) {
        if (newValue) {
          // 禁止
          $(".button").removeClass("btn").addClass("btn_disabled");
        } else {
          $(".button").removeClass("btn_disabled").addClass("btn");
        }
      },
      immediate: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.qgPollutionSourcesMonitor).outerWidth();
    let h = $(that.$refs.qgPollutionSourcesMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    async getData(isCO = false) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.formatTimer) {
        clearTimeout(this.formatTimer);
        this.formatTimer = null;
      }
      let that = this;
      // that.tableData = [];

      let getQgDeviceList = CONFIG.requestName + this.$apiOpt.getQgDeviceList;
      try {
        let data;
        if (isCO) {
          data = await this.$apiUtils.get(getQgDeviceList, {
            customerId: this.customerId,
            co: true,
          });
        } else {
          data = await this.$apiUtils.get(getQgDeviceList, {
            customerId: this.customerId,
          });
        }

        let length = data.length;
        let num = Math.ceil(length / 24);
        let count = Math.ceil(length / 72);
        let tableArr = [];
        for (let i = 0; i < count; i++) {
          let tmpArr = [];
          let tmpOut = data.slice(i * 72, (i + 1) * 72);
          if (tmpOut.length) {
            for (let j = 0; j < num; j++) {
              let tmpInner = tmpOut.slice(j * 24, (j + 1) * 24);
              if (tmpInner.length) {
                tmpInner.forEach((item, index) => {
                  if (!tmpArr[index]) {
                    tmpArr[index] = new Object();
                  }

                  if (j === 0) {
                    tmpArr[index].index1 = i * 72 + index + 1;
                    tmpArr[index].points1 = item.device_name;
                    tmpArr[index].standard1 = item.standard_data || "/";
                    /*if(this.qiangangTest(item)) {
                      tmpArr[index].monitor1 = 0;
                    } else {
                      tmpArr[index].monitor1 = item.value;
                    }*/
                    tmpArr[index].monitor1 = item.value;
                  } else if (j === 1) {
                    tmpArr[index].index2 = i * 72 + index + 25;
                    tmpArr[index].points2 = item.device_name;
                    tmpArr[index].standard2 = item.standard_data || "/";
                    /*if(this.qiangangTest(item)) {
                      tmpArr[index].monitor2 = 0;
                    } else {
                      tmpArr[index].monitor2 = item.value;
                    }*/
                    tmpArr[index].monitor2 = item.value;
                  } else if (j === 2) {
                    if (
                      (item.device_name === "烧结3#360平烧结机头CO" ||
                        item.device_name === "烧结360平烧结机头CO") &&
                      !isCO
                    ) {
                      tmpArr[index].standard3_ = 10000;
                    } else {
                      tmpArr[index].standard3_ = item.standard_data;
                    }
                    tmpArr[index].index3 = i * 72 + index + 49;
                    tmpArr[index].points3 = item.device_name;
                    tmpArr[index].standard3 = item.standard_data || "/";
                    /*if(this.qiangangTest(item)) {
                      tmpArr[index].monitor3 = 0;
                    } else {
                      tmpArr[index].monitor3 = item.value;
                    }*/
                    tmpArr[index].monitor3 = item.value;
                  }
                });
              }
            }
          }
          tableArr[i] = tmpArr;
        }
        this.tableArr = tableArr;
        // this.isAuto && this.formatTableData(tableArr, 0, count);
        if (!this.isAuto) {
          this.tableData = tableArr[this.currentIndex];
        } else {
          this.formatTableData(tableArr, 0, count);
        }
        // data.forEach((element, n) => {
        // if (n % 3 == 0) {
        //   /*that.tableData.push({
        //     index1: n + 1,
        //     points1: element.device_name,
        //     standard1: element.standard_data,
        //     monitor1: element.value,
        //     // paramName1: element.value_name,
        //   });*/
        //   that.tableData[(n + 3) / 3 - 1] = new Object();
        //   that.tableData[(n + 3) / 3 - 1].index1 = n + 1;
        //   that.tableData[(n + 3) / 3 - 1].points1 = element.device_name;
        //   that.tableData[(n + 3) / 3 - 1].standard1 = element.standard_data;
        //   that.tableData[(n + 3) / 3 - 1].monitor1 = element.value;
        // } else if (n % 3 == 1) {
        //   //第(2,4,6,8,10)个
        //   if (!that.tableData[(n + 2) / 3 - 1]) {
        //     that.tableData[(n + 2) / 3 - 1] = new Object();
        //   }
        //   that.tableData[(n + 2) / 3 - 1].index2 = n + 1;
        //   that.tableData[(n + 2) / 3 - 1].points2 = element.device_name;
        //   that.tableData[(n + 2) / 3 - 1].standard2 = element.standard_data;
        //   that.tableData[(n + 2) / 3 - 1].monitor2 = element.value;
        //   // that.tableData[(n + 2) / 3 - 1].paramName2 = element.value_name;
        // } else if (n % 3 == 2) {
        //   if (!that.tableData[(n + 1) / 3 - 1]) {
        //     that.tableData[(n + 1) / 3 - 1] = new Object();
        //   }
        //   that.tableData[(n + 1) / 3 - 1].index3 = n + 1;
        //   that.tableData[(n + 1) / 3 - 1].points3 = element.device_name;
        //   if (
        //     element.device_name == "烧结3#360平烧结机头CO" ||
        //     element.device_name == "烧结360平烧结机头CO"
        //   ) {
        //     that.tableData[(n + 1) / 3 - 1].standard3_ = 10000;
        //   } else {
        //     that.tableData[(n + 1) / 3 - 1].standard3_ = element.standard_data;
        //   }
        //   that.tableData[(n + 1) / 3 - 1].standard3 = element.standard_data;
        //   that.tableData[(n + 1) / 3 - 1].monitor3 = element.value;
        //   // that.tableData[(n + 1) / 3 - 1].paramName3 = element.value_name;
        // }
        // });
        that.$forceUpdate();
      } catch (err) {
        console.log(err);
      }
      this.timer = setTimeout(() => {
        this.getData(isCO);
      }, 30 * 1000);
    },
    getDataCO() {
      this.tableData = [];
      this.timer = setTimeout(() => {
        this.getDataCO();
      }, 30 * 1000);
    },
    formatTableData(list, index, count) {
      this.currentIndex = index;
      if (this.formatTimer) {
        clearTimeout(this.formatTimer);
        this.formatTimer = null;
      }

      if (index < count) {
        this.tableData = list[index];
        index++;
      } else {
        index = 0;
      }
      this.formatTimer = setTimeout(
        () => this.formatTableData(list, index, count),
        15 * 1000
      );
    },
    clickHandle() {
      if (this.isAuto) {
        return;
      }
      if (this.formatTimer) {
        clearTimeout(this.formatTimer);
        this.formatTimer = null;
      }
      if (this.isShowC0) {
        return;
      } else {
        if (this.currentIndex < this.tableArr.length) {
          if (this.tableArr.length - this.currentIndex === 1) {
            this.tableData = this.tableArr[0];
            this.currentIndex = 0;
          } else {
            this.tableData = this.tableArr[++this.currentIndex];
          }
        }
      }
    },
    triggleHandle() {
      this.isAuto = !this.isAuto;
      if (!this.isAuto) {
        if (this.formatTimer) {
          clearTimeout(this.formatTimer);
          this.formatTimer = null;
        }
      }
    },
    triggleCO() {
      this.isShowC0 = !this.isShowC0;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isShowC0) {
        this.tableData = [];
        this.getData(this.isShowC0);
        // this.tableData = []
      } else {
        this.tableData = [];
        this.getData(this.isShowC0);
      }
    },
    // 迁钢测试数据
    qiangangTest(item) {
      if (
        item.signalNo === "QG-JC-CEMS-NY-002_19" ||
        item.signalNo === "QG-JC-CEMS-NY-002_17" ||
        item.signalNo === "QG-JC-CEMS-NY-002_18" ||
        item.signalNo === "QG-JC-CEMS-SJ-006_19" ||
        item.signalNo === "QG-JC-CEMS-SJ-006_18" ||
        item.signalNo === "QG-JC-CEMS-SJ-006_17" ||
        item.signalNo === "QG-JC-CEMS-SJ-006_30" ||
        item.signalNo === "QG-JC-CEMS-SJ-009_19"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.qgPollutionSourcesMonitor .el-table--scrollable-y .el-table__body-wrapper {
  overflow: hidden;
}
.qgPollutionSourcesMonitor {
  width: 1220px;
  height: 790px;
  .searchTitle_ {
    .el-select {
      border-radius: 2px !important;
      border: 1px solid !important;
      border-image: linear-gradient(
          90deg,
          rgba(46, 49, 255, 1),
          rgba(1, 176, 191, 1)
        )
        1 1 !important;
      height: 32px !important;
    }
    .el-select .select-trigger .el-input .el-input__inner {
      height: 32px !important;
      background: linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.64) 0%,
        rgba(11, 10, 34, 0.55) 100%
      ) !important;
      box-shadow: 0px 0px 6px 0px #000000 !important;
      opacity: 1 !important;
      border: none !important;
    }

    .el-input {
      border-radius: 2px !important;
      border: 1px solid !important;
      border-image: linear-gradient(
          90deg,
          rgba(46, 49, 255, 1),
          rgba(1, 176, 191, 1)
        )
        1 1 !important;
    }
    .el-input .el-input__inner {
      height: 28px !important;
      background: linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.64) 0%,
        rgba(11, 10, 34, 0.55) 100%
      ) !important;
      box-shadow: 0px 0px 6px 0px #000000 !important;
      opacity: 1 !important;
      border: none !important;
    }
  }
}

.qgPollutionSourcesMonitor {
  pointer-events: all;

  .source_table {
    border: 1px solid #8badff !important;
    background: #01132d40 !important;
  }
  .thClass {
    background: #01122ba6 !important;
    border-bottom: 1px solid #cccccc28 !important;
    padding: 8px 0px !important;
  }

  .thClass > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .thClass_ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
    padding: 8px 0px !important;
  }

  .thClass_ > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .tdClass {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
    padding: 0 !important;
  }
  .tdClass > .cell {
    font-size: 16px !important;
    color: #e2e2e2 !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .tdClass_2 {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
    padding: 0 !important;
  }
  .tdClass_2 > .cell {
    font-size: 16px !important;
    color: #e2e2e2 !important;
    font-family: "number" !important;
    text-align: center !important;
    // text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0;
  }

  .tdClass_3 {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
    padding: 0 !important;
    padding-left: 10px !important;
  }
  .tdClass_3 > .cell {
    font-size: 15px !important;
    color: #ddd !important;
    text-align: start !important;
    overflow: hidden;
    white-space: nowrap;
    padding: 0;
  }
  .tdClass_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
    padding: 0 !important;
  }

  .tdClass_ > .cell {
    font-size: 16px !important;
    color: #afafaf !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .trClass {
    padding: 0 !important;
  }
  .headTrClass {
    border: 1px solid rgba(132, 170, 255, 0.5) !important;
  }
}
.btn {
  position: absolute;
  right: 20px;
  top: 8px;
  width: 80px;
  height: 40px;
  border: 1px solid rgba(46, 49, 255, 1);
  line-height: 40px;
  text-align: center;
  color: #47ffddff;
  cursor: pointer;
  z-index: 9999;
}
.btn_disabled {
  position: absolute;
  right: 20px;
  top: 8px;
  width: 80px;
  height: 40px;
  border: 1px solid #ccc;
  line-height: 40px;
  text-align: center;
  color: #ccc;
  opacity: 0.5;
  cursor: not-allowed;
  z-index: 9999;
}
.triggleBtn {
  position: absolute;
  right: 160px;
  top: 8px;
  width: 80px;
  height: 40px;
  border: 1px solid rgba(46, 49, 255, 1);
  line-height: 40px;
  text-align: center;
  color: #47ffddff;
  cursor: pointer;
  z-index: 9999;
}
.triggleBtnCo {
  right: 280px;
  letter-spacing: 2px;
}
.highLight {
  background: #04667a86;
}
</style>
<style scoped lang="scss">
.allListBtn {
  color: #4be0ff;
  position: absolute;
  right: 50px;
  top: 50px;
}

.green-dot {
  color: #99f5ffff;
  line-height: 16px;
  font-size: 30px;
}

.red-dot {
  color: #ff7f7fff;
  line-height: 16px;
  font-size: 30px;
}

.gray-dot {
  color: #cccccccc;
  line-height: 16px;
  font-size: 30px;
}

.container_ {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
  pointer-events: all;
}

.searchTitle_ {
  display: inline-block;
  span {
    font-size: 16px;
    font-family: "fontNormal";
    color: #99f5ff;
  }
}

.self_btn {
  background-image: url("img/btn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 45px;
  line-height: 40px;
  display: inline-block;
  cursor: pointer;
}

/*.self_btn:hover{
 background-image: url("img/btn_click.png");
}*/

.self_btn:active {
  background-image: url("img/btn_click.png");
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #f5a623;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
